import React from 'react';
import { SIDEBAR_ID } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/metrics/constants.tsx';
import {
	SidebarReady,
	SidebarRenderStart,
} from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/metrics/main.tsx';
import { Skeleton } from '@atlassian/jira-navigation-apps-sidebar-common/src/ui/skeleton/index.tsx';
import { useFeatures } from '../controllers/features/index.tsx';
import { Menu } from './menu/index.tsx';

export const SidebarUser = () => {
	const { data: features, loading } = useFeatures();

	if (loading || !features) {
		return <Skeleton isFull />;
	}

	return (
		<>
			<SidebarRenderStart />
			<Menu />
			{!__SERVER__ && <SidebarReady id={SIDEBAR_ID.USER} />}
		</>
	);
};
